import React from "react";
import { bind } from "decko";

import ImageGoal from "../img/soccerball.svg";
import ImageShot from "../img/shot.png";
import ImageWhistle from "../img/whistle.svg";
import ImageCards from "../img/cards.png";
import ImageMisc from "../img/more_dots.png";
import ImageSub from "../img/substitution.png";

export default class EventButton extends React.Component {
    constructor(props) {
        super(props);

        this.eventToImg = {
            "goal": ImageGoal,
            "shot": ImageShot,
            "freekick": ImageWhistle, // Use different icon ?
            "card": ImageCards,
            "substitution": ImageSub,//TODO
            "misc": ImageMisc,
        }
    }

    @bind
    clicked() {
        this.props.onClicked(this.props.eventType, this.props.team);
    }

    render() {
        return (
            <div onClick={this.clicked} style={{
                backgroundImage: "url('" + this.eventToImg[this.props.eventType] + "')",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                width: this.props.width,
                height: this.props.height,
                cursor: "pointer",
                border: "solid 1px white",
                borderRadius: "8px",
                margin: "4px 0",
            }} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/EventButton.js